import { styled } from 'theme';
import { fadeIn } from 'theme/animations';
import { zIndices } from 'theme/constants';

const MobileOverlay = styled('div', {
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  position: 'fixed',
  bottom: 0,
  top: 0,
  left: 0,
  right: 0,
  zIndex: zIndices.sideBarOverlay,
  animation: `${fadeIn} 400ms ease`,
  '@md': {
    display: 'none',
  },
});

export default MobileOverlay;
